<template>
  <span class="status-dot" aria-hidden="true"></span>
</template>

<style lang="scss" scoped>
@import '~/_variables.scss';

/* The live light: a vibrant core inside a translucent ring, so it reads as a
   light rather than as a full stop.

   It was written once, inside the chat card, as `.ai-chat-dot`, and the browser
   frame's live badge is the same object: a few pixels of green saying "this is
   running now". That is the point at which a second copy of the rule starts the
   drift the rule itself describes, so the light has one owner and each row that
   shows it decides only what it says beside it.

   The colour is `$online-ink`, which the token file names as the live
   indicator's own green. `$status-good-ink` is deliberately not used: that ink
   is tuned to be read as type and goes olive at this size, and a light is fill
   rather than a letterform. It is therefore one green on either ground, because
   the job does not change with the ground. The text beside it is where a light
   and a dark row differ, and each caller sets that itself.

   The ring is a transparent border rather than a box-shadow, and
   `background-clip: padding-box` is what makes that work: the browser paints a
   background under the border by default, so without the clip the solid green
   runs out to the border's outer edge and the translucent ring disappears into
   it. Clipped, the fill stops at the padding edge and the ring is a genuine
   halo over whatever the light is sitting on.

   Bootstrap sets box-sizing: border-box globally, so the 0.8rem is the whole
   indicator: a 3px ring plus roughly a 7px core. That total is the size the
   lines that carry it can take without the light setting the row's height, and
   it is deliberately the same in both rows, because the light is one object
   rather than one object per row.

   `flex: 0 0 auto` is the light's own guard rather than either caller's: both
   put it in a flex row, and a light that could be squeezed by a long label
   beside it would stop reading as a light. */
.status-dot {
  background: $online-ink;
  background-clip: padding-box;
  border: 3px solid rgba($online-ink, .25);
  border-radius: 50%;
  flex: 0 0 auto;
  height: 0.8rem;
  width: 0.8rem;
}
</style>
